const images = {
  beat: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_ll_monocromatic-positive-h_background.svg`,
  beatWhite: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_ll_monocromatic-positive-h_background.svg`,
  grass: `${process.env.REACT_APP_BASE_ASSETS_URL}app_canal_informacion_partidos/Campo.svg`,
  court: `${process.env.REACT_APP_BASE_ASSETS_URL}app_canal_informacion_partidos/terreno.svg`,
  logoBlackHorizontal: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_laliga-color-h.svg`,
  logoWhiteHorizontal: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_laliga-color-h.svg`,
  logoBlackVertical: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_laliga-color-h.svg`,
  logoWhiteVertical: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/2023_laliga-color-h.svg`,
  logoLaligaSantanderBlack: `${process.env.REACT_APP_BASE_ASSETS_URL}logos/laliga-santander-monocromatic-positive-h.png`,
  horizontalHalfField: `${process.env.REACT_APP_BASE_ASSETS_URL}app_canal_informacion_partidos/campo_izqda.svg`,
  lockView: `${process.env.REACT_APP_BASE_ASSETS_URL}app_canal_informacion_partidos/change_orientation.gif`,
  notFoundBackground: `${process.env.REACT_APP_BASE_ASSETS_URL}app_canal_informacion_partidos/404.jpg`,
  flags: `${process.env.REACT_APP_BASE_ASSETS_URL}flags`,
  personPlaceholder:
    'https://assets.laliga.com/assets/useful/default-player/512x512/manager_003.png',
  playerPlaceholder: `${process.env.REACT_APP_BASE_ASSETS_URL}jugadores/male_001.png`,
  warning: `${process.env.REACT_APP_BASE_ASSETS_URL}app_manager/warning.png`,
};

export default images;
